
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("i6jK3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3BZZG = parcelRequire("3BZZG");


var $46EIy = parcelRequire("46EIy");


var $g9Jfe = parcelRequire("g9Jfe");


var $gxsT9 = parcelRequire("gxsT9");

class $8bf56a890c163c32$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const numChildren = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(this.props.children);
        let content;
        if (numChildren === 1) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const card = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(this.props.children)[0];
            switch(card.props.type){
                case 'file':
                    content = this.renderSingleFile(card);
                    break;
                case 'link':
                    content = null;
                    break;
                default:
                    content = this.renderSingleLink(card);
            }
        } else content = this.renderStrip();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: "MediaGroup",
            ...(0, $gxsT9.VcMediaWrapperProps)
        }, content));
    }
    renderSingleFile(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            // the media group component renders in crop mode in editor thus this enables consistency
            // also crop is much easier to make consistent across SSR and hydration
            resizeMode: (0, $g9Jfe.fg)('media-perf-uplift-mutation-fix') ? 'crop' : 'stretchy-fit',
            cardDimensions: (0, $3BZZG.defaultImageCardDimensions),
            useInlinePlayer: false,
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderSingleLink(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            appearance: 'auto',
            featureFlags: this.props.featureFlags
        });
    }
    cloneFileCard(child, surroundingItems) {
        const cardClickHandler = this.props && this.props.eventHandlers && this.props.eventHandlers.media && this.props.eventHandlers.media.onClick;
        const onClick = cardClickHandler ? this.onMediaClick(cardClickHandler, child, surroundingItems) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            useInlinePlayer: false,
            eventHandlers: {
                ...child.props.eventHandlers,
                media: {
                    onClick: onClick
                }
            },
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderStrip() {
        const { children: children } = this.props;
        const { animate: animate, offset: offset } = this.state;
        const childIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child)=>{
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return this.mapMediaPropsToIdentifier(child.props);
        });
        const surroundingItems = (childIdentifiers || []).filter((identifier)=>!!identifier);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46EIy.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: this.handleSize,
            onScroll: this.handleScroll
        }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (rawChild)=>{
            const child = rawChild;
            switch(child.props.type){
                case 'file':
                    return this.cloneFileCard(child, surroundingItems);
                case 'link':
                    return null;
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                        featureFlags: this.props.featureFlags,
                        enableDownloadButton: this.props.enableDownloadButton
                    });
            }
        }));
    }
    mapMediaPropsToIdentifier({ id: id, type: type, occurrenceKey: occurrenceKey, collection: collection }) {
        switch(type){
            case 'file':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: type,
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
            case 'link':
                return undefined;
            case 'external':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: 'file',
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
        }
    }
    constructor(...args){
        super(...args);
        this.state = {
            animate: false,
            offset: 0
        };
        this.handleSize = ({ offset: offset })=>this.setState({
                offset: offset
            });
        this.handleScroll = ({ animate: animate, offset: offset })=>this.setState({
                animate: animate,
                offset: offset
            });
        this.onMediaClick = (cardClickHandler, child, surroundingItems)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (event, analyticsEvent)=>{
                const surroundings = {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    collectionName: child.props.collection,
                    list: surroundingItems
                };
                cardClickHandler(event, surroundings, analyticsEvent);
            };
    }
}
module.exports["default"] = $8bf56a890c163c32$export$2e2bcd8739ae039;

});


//# sourceMappingURL=mediaGroup.180c8bdb.js.map
